import { Box, BoxProps } from '@qga/roo-ui/components';
import { useBookingList } from '../BookingListProvider';
import LoadingBlock from 'components/LoadingBlock';
import LoadMoreButton from './LoadMoreButton';
import NoUpcomingBookings from '../NoUpcomingBookings';
import { UpcomingBookingCard, PastBookingCard, CancelledBookingCard } from '../Card';

const BookingList = (props: BoxProps) => {
  const { filter, loading, bookings, hasMore, loadMore } = useBookingList();

  return (
    <Box data-testid={`${filter}-booking-list`} {...props}>
      <Box>
        {bookings.map((booking) => {
          if (filter === 'past') {
            return <PastBookingCard booking={booking} key={`booking-${booking.reference}`} />;
          } else if (filter === 'cancelled') {
            return <CancelledBookingCard booking={booking} key={`booking-${booking.reference}`} />;
          }
          return <UpcomingBookingCard booking={booking} key={`booking-${booking.reference}`} />;
        })}
      </Box>
      {!loading && bookings.length === 0 && filter === 'upcoming' && <NoUpcomingBookings />}
      {loading && <LoadingBlock />}
      {!loading && hasMore && <LoadMoreButton onClick={loadMore} loading={loading} />}
    </Box>
  );
};

export default BookingList;
